import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useWorkflowStore } from '@/stores/workflowStore';
import { toast } from 'sonner';

interface WorkflowCreatorProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WorkflowCreator({ open, onOpenChange }: WorkflowCreatorProps) {
  const [name, setName] = useState('');
  const { createWorkflow } = useWorkflowStore();

  const handleCreate = () => {
    if (!name.trim()) {
      toast.error('Workflow name required');
      return;
    }
    createWorkflow(name);
    setName('');
    onOpenChange(false);
    toast.success(`Workflow "${name}" created`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create New Workflow</DialogTitle>
          <DialogDescription>
            Give your workflow a name to get started
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="workflow-name">Workflow Name</Label>
            <Input
              id="workflow-name"
              placeholder="e.g., Daily Report Generator"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
              autoFocus
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleCreate}>Create</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
